module.exports = __webpack_public_path__ + "static/media/radio.0ee82d41.svg";